import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { store } from "store";
Vue.mixin({
    computed: {
        $store: function () { return store; },
        $state: function () { return store.state; },
        $ui: function () { return store.ui; },
        $cart: function () { return store.cart; },
        $configuration: function () { return store.configuration; },
    }
});
export function padLeft(source, n, padStr) {
    return Array(n - String(source.toFixed(0)).length + 1).join(padStr || "0") + source.toFixed(0);
}
export { Vue, Component, Prop, Watch };
